import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  id: "create-booking-shipment",
  class: "w-full h-full"
}
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = {
  class: "px-6 w-full border-b border-t border-gray-lp-2100",
  style: {"margin-top":"6px"}
}
const _hoisted_4 = {
  class: "flex flex-row items-center font-semibold gap-4 text-xl",
  style: {"padding":"6px"}
}
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "w-6 h-6",
  src: _imports_0,
  alt: "back"
}, null, -1)
const _hoisted_6 = {
  id: "tab-content",
  class: "w-full h-full pb-10 bg-gray-lp-1000 p-3"
}
const _hoisted_7 = {
  key: 0,
  class: "rounded-xl p-3 bg-white"
}
const _hoisted_8 = {
  key: 1,
  class: "rounded-xl py-36 bg-white"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScanBookingShipment = _resolveComponent("ScanBookingShipment")!
  const _component_ShipmentStatusHeader = _resolveComponent("ShipmentStatusHeader")!
  const _component_ShipmentTable = _resolveComponent("ShipmentTable")!
  const _component_EmptyList = _resolveComponent("EmptyList")!
  const _component_ModalSuccessBooking = _resolveComponent("ModalSuccessBooking")!
  const _component_ModalSuccessBookingV4 = _resolveComponent("ModalSuccessBookingV4")!
  const _component_ModalFailedShipment = _resolveComponent("ModalFailedShipment")!
  const _component_ModalFailedBookingV4 = _resolveComponent("ModalFailedBookingV4")!
  const _component_ModalShipmentV3 = _resolveComponent("ModalShipmentV3")!
  const _component_ModalShipmentV4 = _resolveComponent("ModalShipmentV4")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
            }, [
              _hoisted_5
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.title")), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_ScanBookingShipment, {
          modelValue: _ctx.shipmentId,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.shipmentId = $event)),
          isLoading: _ctx.isScanQueueRunning,
          onScanShipment: _ctx.onScanShipment,
          onScanInstant: _ctx.onScanShipment,
          scanLogEntries: _ctx.scanPanelEntries,
          onInstantBookingChange: _ctx.onInstantBookingChange
        }, null, 8, ["modelValue", "isLoading", "onScanShipment", "onScanInstant", "scanLogEntries", "onInstantBookingChange"]),
        (_ctx.allShipmentGroups.length)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode(_component_ShipmentStatusHeader, {
                ref: "shipment-status-header",
                data: _ctx.allShipmentGroups,
                isSuccessBooking: _ctx.filter.isSuccessBooking,
                "onUpdate:isSuccessBooking": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.isSuccessBooking = $event)),
                isNotBooked: _ctx.filter.isNotBooked,
                "onUpdate:isNotBooked": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filter.isNotBooked = $event)),
                isFailedBooking: _ctx.filter.isFailedBooking,
                "onUpdate:isFailedBooking": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filter.isFailedBooking = $event)),
                isAscendingSort: _ctx.filter.isAscending,
                "onUpdate:isAscendingSort": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filter.isAscending = $event)),
                onPrintAll: _ctx.onPrintAll
              }, null, 8, ["data", "isSuccessBooking", "isNotBooked", "isFailedBooking", "isAscendingSort", "onPrintAll"]),
              _createVNode(_component_ShipmentTable, {
                shipmentData: _ctx.filteredShipmentIdData,
                onBookingShipment: _ctx.onBookingShipment,
                onEditShipment: _ctx.onEditShipment,
                onDeleteShipment: _ctx.onDeleteShipment,
                onAddAddress: _ctx.onAddAddress,
                onPrint: _ctx.onPrintSttShipment
              }, null, 8, ["shipmentData", "onBookingShipment", "onEditShipment", "onDeleteShipment", "onAddAddress", "onPrint"])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode(_component_EmptyList, {
                customHeaderMessage: 
            _ctx.$t('bookingShipment.appsMarketplace.emptyHeader')
          ,
                customMessage: _ctx.$t('bookingShipment.appsMarketplace.emptyMessage')
              }, null, 8, ["customHeaderMessage", "customMessage"])
            ]))
      ]),
      (_ctx.isShowModalSuccessBooking && !_ctx.stateIsNewBooking)
        ? (_openBlock(), _createBlock(_component_ModalSuccessBooking, {
            key: 0,
            data: _ctx.modalSuccessBookingData,
            onClose: _ctx.onCloseSuccessBooking,
            onPrint: _ctx.printPDFOnSuccessBooking,
            formType: _ctx.hideTariffSuccessBooking ? 'client' : 'manual',
            isButtonCreateInvoice: false,
            isCrossCountryCod: _ctx.isCrossCountryCod,
            prefixCurrency: _ctx.prefixCurrency
          }, null, 8, ["data", "onClose", "onPrint", "formType", "isCrossCountryCod", "prefixCurrency"]))
        : (_ctx.isShowModalSuccessBooking)
          ? (_openBlock(), _createBlock(_component_ModalSuccessBookingV4, {
              key: 1,
              data: _ctx.modalSuccessBookingData,
              receiptFormat: "a6",
              bookingClient: _ctx.hideTariffSuccessBooking,
              isButtonCreateInvoice: false,
              totalPieces: _ctx.modalSuccessTotalPieces,
              isCrossCountryCod: _ctx.isCrossCountryCod,
              prefixCurrency: _ctx.prefixCurrency,
              onClose: _ctx.onCloseSuccessBooking,
              onPrint: _ctx.printPDFOnSuccessBooking
            }, null, 8, ["data", "bookingClient", "totalPieces", "isCrossCountryCod", "prefixCurrency", "onClose", "onPrint"]))
          : _createCommentVNode("", true),
      (!_ctx.stateIsNewBooking)
        ? (_openBlock(), _createBlock(_component_ModalFailedShipment, _mergeProps({
            key: 2,
            modelValue: _ctx.isShowModalFailedBooking,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowModalFailedBooking = $event))
          }, _ctx.modalFailedBookingData, {
            onClose: _ctx.onCloseFailedBooking,
            onReload: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onReloadBooking())),
            onScrollToDestination: _ctx.onCloseFailedBooking,
            onScrollToCod: _ctx.onCloseFailedBooking,
            onScrollToCommodity: _ctx.onCloseFailedBooking
          }), null, 16, ["modelValue", "onClose", "onScrollToDestination", "onScrollToCod", "onScrollToCommodity"]))
        : (_openBlock(), _createBlock(_component_ModalFailedBookingV4, _mergeProps({
            key: 3,
            modelValue: _ctx.isShowModalFailedBooking,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.isShowModalFailedBooking = $event))
          }, _ctx.modalFailedBookingData, {
            onClose: _ctx.onCloseFailedBooking,
            onReload: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onReloadBooking())),
            onScrollToDestination: _ctx.onCloseFailedBooking,
            onScrollToCod: _ctx.onCloseFailedBooking,
            onScrollToCommodity: _ctx.onCloseFailedBooking
          }), null, 16, ["modelValue", "onClose", "onScrollToDestination", "onScrollToCod", "onScrollToCommodity"]))
    ]),
    (!_ctx.stateIsNewBooking)
      ? (_openBlock(), _createBlock(_component_ModalShipmentV3, {
          key: 0,
          ref: "modal-shipment",
          modelValue: _ctx.isBookingShipment,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.isBookingShipment = $event)),
          data: _ctx.shipmentList,
          selectedIndex: _ctx.selectedIndex,
          "onUpdate:selectedIndex": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectedIndex = $event)),
          isAddAddress: _ctx.isAddAddress,
          onBookingShipment: _ctx.onBookingFromModal,
          isShipment: true
        }, null, 8, ["modelValue", "data", "selectedIndex", "isAddAddress", "onBookingShipment"]))
      : (_openBlock(), _createBlock(_component_ModalShipmentV4, {
          key: 1,
          ref: "modal-shipment-v4",
          modelValue: _ctx.isBookingShipment,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.isBookingShipment = $event)),
          data: _ctx.shipmentList,
          selectedIndex: _ctx.selectedIndex,
          "onUpdate:selectedIndex": _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectedIndex = $event)),
          isAddAddress: _ctx.isAddAddress,
          onBookingShipment: _ctx.onBookingFromModal,
          onSkip: _ctx.onSkipShipment,
          isShipment: true
        }, null, 8, ["modelValue", "data", "selectedIndex", "isAddAddress", "onBookingShipment", "onSkip"]))
  ], 64))
}